<template>
  <div class="roles-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>小程序角色管理</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="handleAddRole" v-permission="'btn:xcxRole:add'">新增角色</el-button>
      </div>

      <!-- 角色列表 -->
      <el-table :data="roleList" style="width: 100%" border>
        <el-table-column prop="roleKey" label="角色标识" width="180"></el-table-column>
        <el-table-column prop="roleName" label="角色名称" width="180"></el-table-column>
        <el-table-column prop="roleDesc" label="角色描述"></el-table-column>
        <el-table-column label="操作" width="280">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleAssignPermission(scope.row)" v-permission="'btn:xcxRole:assign'">分配权限</el-button>
            <el-button size="mini" @click="handleEditRole(scope.row)" v-permission="'btn:xcxRole:edit'" v-if="scope.row.isDelete == '1'">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDeleteRole(scope.row)" v-permission="'btn:xcxRole:delete'" v-if="scope.row.isDelete == '1'">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 角色表单对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="roleDialogVisible" width="500px">
      <el-form :model="roleForm" :rules="roleRules" ref="roleForm" label-width="100px">
        <el-form-item label="角色标识" prop="roleKey">
          <el-input v-model.trim="roleForm.roleKey" :disabled="!roleForm.addFlag" @input="val => roleForm.roleKey = val.replace(/\s/g, '')" placeholder="请输入角色标识，如：admin, user"></el-input>
        </el-form-item>
        <el-form-item label="角色名称" prop="roleName">
          <el-input v-model.trim="roleForm.roleName" @input="val => roleForm.roleName = val.replace(/\s/g, '')" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="角色描述" prop="roleDesc">
          <el-input type="textarea" v-model.trim="roleForm.roleDesc" placeholder="请输入角色描述"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="roleDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitRoleForm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 权限分配对话框 -->
    <el-dialog title="分配权限" :visible.sync="permissionDialogVisible" width="600px">
      <div v-if="currentRole" class="permission-title">
        正在为角色 <span class="role-name">{{ currentRole.roleName }}</span> 分配权限
      </div>

      <div class="permission-container">
        <div class="menu-permissions">
          <h3>菜单与按钮权限</h3>
          <el-tree
            ref="menuTree"
            :data="menuTreeData"
            show-checkbox
            default-expand-all
            node-key="id"
            :props="defaultProps"
            @node-click="handleNodeClick">
            <span class="custom-tree-node" slot-scope="{ data }">
              <span>
                <i v-if="data.icon" :class="data.icon"></i>
                {{ data.lbname || data.name }}
                <el-tag size="mini" v-if="data.type === 2" type="success">按钮</el-tag>
              </span>
            </span>
          </el-tree>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="permissionDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveRolePermissions">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Roles',
  data() {
    return {
      // 角色列表
      roleList: [],

      // 角色对话框
      roleDialogVisible: false,
      dialogTitle: '新增角色',
      roleForm: {
        id: null,
        roleName: '',
        roleKey: '',
        roleDesc: ''
      },
      roleRules: {
        roleName: [
          { required: true, message: '请输入角色名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        roleKey: [
          { required: true, message: '请输入角色标识', trigger: 'blur' },
          { pattern: /^[a-zA-Z_]{2,20}$/, message: '角色格式只能是大小写字母、_，长度2-20之间', trigger: 'blur' }
        ]
      },

      // 权限分配对话框
      permissionDialogVisible: false,
      currentRole: null,
      menuTreeData: [],
      defaultProps: {
        children: 'children',
        label: 'lbname'
      },
      checkedKeys: []
    }
  },
  created() {
    this.getRoleList()
  },
  methods: {
    // 获取角色列表
    async getRoleList() {
      try {
        const { data: res } = await this.$http.get('/xcxRole/list')
        if (res.code !== 200) {
          return this.$message.error('获取角色列表失败')
        }
        this.roleList = res.data
      } catch (error) {
        console.error('获取角色列表失败:', error)
        this.$message.error('获取角色列表失败')
      }
    },

    // 新增角色
    handleAddRole() {
      this.dialogTitle = '新增角色'
      this.roleForm = {
        addFlag: true,
        roleName: '',
        roleKey: '',
        roleDesc: ''
      }
      this.roleDialogVisible = true
      this.$nextTick(() => {
        this.$refs.roleForm && this.$refs.roleForm.clearValidate()
      })
    },

    // 编辑角色
    handleEditRole(role) {
      this.dialogTitle = '编辑角色'
      this.roleForm = JSON.parse(JSON.stringify(role))
      this.roleForm.addFlag = false
      this.roleDialogVisible = true
      this.$nextTick(() => {
        this.$refs.roleForm && this.$refs.roleForm.clearValidate()
      })
    },

    // 删除角色
    handleDeleteRole(role) {
      this.$confirm(`确认删除角色 ${role.roleName}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const { data: res } = await this.$http.delete(`/xcxRole/delete/${role.roleKey}`)
          if (res.code !== 200) {
            return this.$message.error(res.msg || '删除角色失败')
          }
          this.$message.success('删除角色成功')
          this.getRoleList()
        } catch (error) {
          console.error('删除角色失败:', error)
          this.$message.error('删除角色失败')
        }
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    // 提交角色表单
    submitRoleForm() {
      this.$refs.roleForm.validate(async valid => {
        if (!valid) return

        try {
          let url = '/xcxRole/add'
          if (!this.roleForm.addFlag) {
            url = '/xcxRole/update'
          }

          const { data: res } = await this.$http.post(url, this.roleForm)
          if (res.code !== 200) {
            return this.$message.error(res.msg || '保存角色失败')
          }

          this.$message.success('保存角色成功')
          this.roleDialogVisible = false
          this.getRoleList()
        } catch (error) {
          console.error('保存角色失败:', error)
          this.$message.error('保存角色失败')
        }
      })
    },

    // 分配权限
    async handleAssignPermission(role) {
      this.currentRole = role
      this.permissionDialogVisible = true

      try {
        // 获取所有菜单数据（包括按钮）
        const { data: menuRes } = await this.$http.get('/getXcxMenuList/')
        console.log('菜单数据:', menuRes)

        // 检查返回的数据格式
        if (menuRes.status !== 0) {
          return this.$message.error('获取菜单数据失败')
        }

        // 直接使用后端返回的层次化菜单树数据
        this.menuTreeData = menuRes.data

        // 等待下一个tick，确保树组件已经渲染完成
        await this.$nextTick()

        // 获取角色已有的权限
        const { data: permRes } = await this.$http.get(`/xcxRole/permissions/${role.roleKey}`)
        if (permRes.code !== 200) {
          return this.$message.error('获取角色权限失败')
        }

        console.log('获取到的角色权限:', permRes.data)

        // 合并菜单和按钮权限ID到一个数组
        const menuIds = permRes.data.menuIds || [];

        console.log('=== 权限回显调试信息 ===')
        console.log('角色ID:', role.id)
        console.log('菜单权限ID数组:', menuIds)

        // 过滤出叶子节点（没有子节点的节点）
        // Element UI Tree 的 setCheckedKeys 只需要传入叶子节点的ID
        // 它会自动根据叶子节点的选中状态来计算父节点的选中/半选中状态
        const leafNodeIds = this.getLeafNodeIds(menuIds)
        console.log('过滤后的叶子节点ID:', leafNodeIds)
        console.log('=== 权限回显调试信息结束 ===')

        // 使用setCheckedKeys方法动态设置选中状态，只传入叶子节点
        if (this.$refs.menuTree) {
          this.$refs.menuTree.setCheckedKeys(leafNodeIds)
        }

        // 同时更新checkedKeys数据，用于后续操作
        this.checkedKeys = leafNodeIds

      } catch (error) {
        console.error('获取权限数据失败:', error)
        this.$message.error('获取权限数据失败')
      }
    },

    // 处理节点点击事件
    handleNodeClick() {
      // 简单的点击处理，不做特殊操作
    },
    // 保存角色权限
    async saveRolePermissions() {
      if (!this.currentRole) return

      try {
        // 获取选中的所有节点ID
        const checkedKeys = this.$refs.menuTree.getCheckedKeys()
        // 获取半选中的节点（通常是父菜单节点）
        const halfCheckedKeys = this.$refs.menuTree.getHalfCheckedKeys()

        // 将所有选中的节点分为菜单和按钮
        const allNodes = this.getAllNodesMap()
        const menuIds = []

        // 处理完全选中的节点
        for (let i = 0; i < checkedKeys.length; i++) {
          const id = checkedKeys[i];
          const node = allNodes[id];
          if (node) {
            if (node.type === 1) {
              menuIds.push(id);
            }
          }
        }

        // 处理半选中的菜单节点（用户想要菜单权限但不要所有按钮权限的情况）
        for (let i = 0; i < halfCheckedKeys.length; i++) {
          const id = halfCheckedKeys[i];
          const node = allNodes[id];
          if (node && node.type === 1) {
            // 只添加菜单类型的半选中节点，避免重复添加
            if (!menuIds.includes(id)) {
              menuIds.push(id);
            }
          }
        }

        const data = {
          roleKey: this.currentRole.roleKey,
          menuIds: menuIds
        }

        console.log('=== 保存权限调试信息 ===')
        console.log('角色ID:', this.currentRole.roleKey)
        console.log('完全选中的节点:', checkedKeys)
        console.log('半选中的节点:', halfCheckedKeys)
        console.log('保存的菜单权限:', menuIds)
        console.log('发送到后端的数据:', data)
        console.log('=== 保存权限调试信息结束 ===')

        const { data: res } = await this.$http.post('/xcxRole/assign-permissions', data)
        if (res.code !== 200) {
          return this.$message.error(res.msg || '保存权限失败')
        }

        this.$message.success('保存权限成功')
        this.permissionDialogVisible = false
      } catch (error) {
        console.error('保存权限失败:', error)
        this.$message.error('保存权限失败')
      }
    },

    // 获取所有节点的Map，用于快速查找
    getAllNodesMap() {
      const nodeMap = {}

      const traverseTree = (nodes) => {
        if (!nodes) return

        nodes.forEach(node => {
          nodeMap[node.id] = node
          if (node.children && node.children.length > 0) {
            traverseTree(node.children)
          }
        })
      }

      traverseTree(this.menuTreeData)
      return nodeMap
    },

    // 过滤出叶子节点ID（没有子节点的节点）
    getLeafNodeIds(checkedIds) {
      const allNodes = this.getAllNodesMap()
      const leafIds = []

      checkedIds.forEach(id => {
        const node = allNodes[id]
        // 如果节点存在且没有子节点，或者子节点数组为空，则认为是叶子节点
        if (node && (!node.children || node.children.length === 0)) {
          leafIds.push(id)
        }
      })

      return leafIds
    }
  }
}
</script>

<style scoped>
.roles-container {
  padding: 20px;
}

.role-name {
  font-weight: bold;
  color: #409EFF;
}

.permission-title {
  margin-bottom: 20px;
  font-size: 16px;
}

.permission-container {
  padding: 10px;
}

.menu-permissions {
  width: 100%;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.el-tag {
  margin-left: 8px;
}
</style>
